
import { Toaster } from 'react-hot-toast';
import './App.css';

import Mahihmathi from './component/Mahihmathi';

function App() {
  return (
    <div className="App">
       <Toaster position="top-center" reverseOrder={false} />
      

      <Mahihmathi/>
    </div>
  );
}

export default App;
